import { render, staticRenderFns } from "./SpecialistSsnSearch.vue?vue&type=template&id=4acc65b4&scoped=true"
import script from "./SpecialistSsnSearch.vue?vue&type=script&lang=js"
export * from "./SpecialistSsnSearch.vue?vue&type=script&lang=js"
import style0 from "./SpecialistSsnSearch.vue?vue&type=style&index=0&id=4acc65b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc65b4",
  null
  
)

export default component.exports